export enum ConnectState {
    Success = 'ok',
	Error = 'warn',
	Pending = 'pending'
}

export const ConnectStateValues = Object.values(ConnectState);